<template>
  <div class="tab-points">
    <div class="points-header">
      <h3 class="points-title">{{$t('widgets_basic_member_center_components_tab_points_2606')}}</h3>
      <span class="points-points">{{$t('widgets_basic_member_center_components_tab_points_2607')}}</span>
    </div>
    <div class="mock-table-pointers mock-table">
      <div class="mock-tr mock-theader">
        <div class="mock-th td-time" :style="$parent.labelStyle">{{$t('widgets_basic_member_center_components_tab_points_2608')}}</div>
        <div class="mock-th td-action" :style="$parent.labelStyle">{{$t('widgets_basic_member_center_components_tab_points_2609')}}</div>
        <div class="mock-th td-pointers" :style="$parent.labelStyle">{{$t('widgets_basic_member_center_components_tab_points_2610')}}</div>
      </div>
      <div class="mock-tr">
        <div class="mock-td td-time" :style="contentStyle">2021-07-28 10:20:50</div>
        <div class="mock-td td-action" :style="contentStyle">{{$t('widgets_basic_member_center_components_tab_points_2611')}}</div>
        <div class="mock-td td-pointers" :style="contentStyle">300</div>
      </div>
      <div class="mock-tr">
        <div class="mock-td td-time" :style="contentStyle">2021-07-28 10:20:50</div>
        <div class="mock-td td-action" :style="contentStyle">{{$t('widgets_basic_member_center_components_tab_points_2611')}}</div>
        <div class="mock-td td-pointers" :style="contentStyle">300</div>
      </div>
      <div class="mock-tr">
        <div class="mock-td td-time" :style="contentStyle">2021-07-28 10:20:50</div>
        <div class="mock-td td-action" :style="contentStyle">{{$t('widgets_basic_member_center_components_tab_points_2611')}}</div>
        <div class="mock-td td-pointers" :style="contentStyle">300</div>
      </div>
      <div class="mock-tr">
        <div class="mock-td td-time" :style="contentStyle">2021-07-28 10:20:50</div>
        <div class="mock-td td-action" :style="contentStyle">{{$t('widgets_basic_member_center_components_tab_points_2612')}}</div>
        <div class="mock-td td-pointers" :style="contentStyle">300</div>
      </div>
    </div>
    <my_page_index
      :page="page"
      :currentPage.sync="currentPage"
      :total="total"
      @change-page="onChangePage"
    ></my_page_index>
  </div>
</template>

<script>
import i18n from '../../../language/index'

export default {
  name: "basic_member_center_points.vue",
  props: {},
  data() {
    return {
      page: {
        radioValue: false,
        pageSize: 20,
        pageStyle: 0,
      },
      currentPage: 1,
      total: 999
    }
  },
  computed: {
    infor() {
      return this.module.data[this.$store.state.app.view_pattern + '_widgets_infor']
    },
    pc_widgets_infor() {
      return this.module.data.pc_widgets_infor
    },
    mb_widgets_infor() {
      return this.module.data.mb_widgets_infor
    },
    listArr() {
      return this.module.data.listArr
    },
    contentStyle() {
      let style = Object.assign({}, this.$parent.contentStyle)
      style.background = 'transparent'
      return style
    }
  },
  methods: {
    onChangePage(page) {
      this.$message.info(i18n.t('widgets_basic_member_center_components_tab_points_2613'))
    }
  }
}
</script>

<style scoped lang="scss">
.tab-points {
  width: 100%;
}

.points-header {
  margin-top: 35px;
}

.points-title {
  font-size: 22px;
  color: #333;
  display: inline-block;
}

.points-points {
  font-size: 18px;
  display: inline-block;
  margin-left: 20px;
}

.mock-table-pointers {
  margin-top: 20px;
}

.mock-table {
  display: flex;
  flex-direction: column;
}

.mock-theader {
  background: #FAFAFB;
}

.mock-th {
  color: #63658B;
  font-size: 18px;
}

.mock-th, .mock-td {
  padding-left: 10px;
  padding-right: 5px;
  padding-top: 18px;
  padding-bottom: 18px;
}

.mock-tr {
  display: flex;
}

.mock-tr:hover {
  box-shadow: 0px 0px 17px 0px rgba(153, 153, 153, 0.25);
}

.mock-theader:hover {
  box-shadow: none;
}

.mock-td {
  font-size: 14px;
}

.td-time {
  flex: 1;
  flex-basis: 210px;
}

.td-username {
  flex-basis: 210px;
}

.td-phone {
  flex-basis: 210px;
}

.td-email {
  flex-basis: 210px;
}

.td-action {
  flex: 1;
  flex-basis: 210px;

}

.td-pointers {
  flex: 1;
  flex-basis: 210px;

}

.mb_pattern {
  .tab-points {
    padding-left: 5%;
    padding-right: 5%;
  }

  .mock-theader {
    background: transparent;
  }

  .td-action {
    display: none;
  }

  .td-time {
    flex-basis: 350px;
  }
}

</style>



// WEBPACK FOOTER //
// src/widgets/basic_member_center/components/tab-points.vue